import { multiVariantStyles } from './themes/PrefixSuffixStyles.css';

type Props = {
  hasEndContent?: boolean;
  hasInsideLabel?: boolean;
  hasStartContent?: boolean;
  id: string;
  isDisabled?: boolean;
  isFocused?: boolean;
  text: string;
  variant: 'prefix' | 'suffix';
};

export function PrefixSuffix({
  hasEndContent,
  hasInsideLabel,
  hasStartContent,
  id,
  isDisabled,
  isFocused,
  text,
  variant
}: Props) {
  const variantClasses = multiVariantStyles({
    variant,
    isFocused: isFocused ? 'yes' : 'no',
    isDisabled: isDisabled ? 'yes' : 'no',
    hasInsideLabel: hasInsideLabel ? 'yes' : 'no',
    hasStartContent: hasStartContent ? 'yes' : 'no',
    hasEndContent: hasEndContent ? 'yes' : 'no'
  });

  return (
    <div class={variantClasses} id={id}>
      <span>{text}</span>
    </div>
  );
}
